import { InputAdornment, TextField } from '@mui/material';
import { UseControllerProps, useController } from 'react-hook-form';
import { formatCurrencyInputValue } from '../../../../Helpers/CurrencyFormatter';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  error: {
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
  },
});

interface IProps extends UseControllerProps {
  disabled?: boolean | undefined;
  label: string;
  multiline?: boolean;
  rows?: number;
  type?: string;
  value?: string;
  size?: "small" | "medium";
  onlyAllowCurrency?: boolean | false;
  showError?: boolean;
}

const AppCurrencyInput = (props: IProps) => {
  const { fieldState, field } = useController({
    ...props, defaultValue: null,
    rules: {
      validate: value => !/\.\d{3,}/.test(value) || 'Invalid input',
    },
  });
  const value = formatCurrencyInputValue(field.value, 2);
  const classes = useStyles();

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (props.onlyAllowCurrency) {
      const numericValue = event.target.value.replace(/[^0-9.,\,,\.,\s]/g, '');
      field.onChange(numericValue);
    }
    else {
      field.onChange(event);
    }
  }

  return (
    <TextField
      {...props}
      {...field}
      value={value}
      fullWidth
      variant='outlined'
      type={props.type}
      onChange={handleValueChange}
      error={!!fieldState.error || props.showError}
      className={fieldState.error ? classes.error : ''}
      helperText={fieldState.error?.message}
      multiline={props.multiline}
      rows={props.rows}
      disabled={props.disabled || false}
      size={props.size}
      defaultValue={props.defaultValue}
      InputProps={{
        startAdornment: <InputAdornment position="start">R</InputAdornment>,
      }}

    />
  )
}

export default AppCurrencyInput